import { isNil, isArray, merge, get, reduce, cloneDeep } from 'lodash';
import { immutableMergeWith } from 'modules/taboola-common-frontend-modules/utils/customMergers';
import updateObject from 'modules/taboola-common-frontend-modules/utils/updateObject';

const updateReportDimensionMapOnSuccess = (state, action, dimensionName) => {
    const data = action.payload;
    let dataPatch;

    if (isArray(data)) {
        dataPatch = reduce(
            data,
            (acc, item) => {
                const id = item.id || item.campaignsGroupId;

                if (!isNil(id)) {
                    acc[id] = item;
                }

                return acc;
            },
            {}
        );
    } else {
        const id = data.id || data.campaignsGroupId;

        if (isNil(id)) {
            return state;
        }

        dataPatch = { [id]: data };
    }

    const dimensionMap = immutableMergeWith(state[dimensionName], dataPatch);

    return updateObject(state, { [dimensionName]: dimensionMap });
};

const updateReportDimensionMapOnError = (state, action, dimensionName) => {
    const data = action.payload;
    let dimensionMap;

    if (isArray(data)) {
        dimensionMap = reduce(
            data,
            (acc, item) => {
                const id = item.id || item.campaignsGroupId;

                if (!isNil(id)) {
                    return merge(acc, {
                        [id]: { ...state[dimensionName][id] },
                    });
                }

                return acc;
            },
            cloneDeep(state[dimensionName])
        );
    } else {
        const { id } = data;
        dimensionMap = merge({}, state[dimensionName], {
            [id]: { ...get(state[dimensionName], id) },
        });
    }

    return updateObject(state, { [dimensionName]: dimensionMap });
};

export { updateReportDimensionMapOnSuccess, updateReportDimensionMapOnError };
